import { TransactionType } from "./transactionType";
import { DPE } from "./dpe";

export class Ad {
    id: string;
    estatetype: string;
    price: number;
    surface: number;
    description: string;
    title: string;
    images: string[];
    visible: boolean;
    transactiontype: TransactionType;
    dpe: DPE;

    public constructor(
        id: string,
        estatetype: string,
        price: number,
        surface: number,
        description: string,
        title: string,
        images: string[],
        visible: boolean,
        transactiontype: TransactionType,
        dpe: DPE) {
        this.id = id;
        this.estatetype = estatetype;
        this.price = price;
        this.surface = surface;
        this.description = description;
        this.title = title;
        this.images = images;
        this.visible = visible;
        this.transactiontype = transactiontype;
        this.dpe = dpe;
    }

    public static createAdFromJsonObject(item: any) {
        return new Ad(
            item.id,
            item.estatetype,
            item.price,
            item.surface,
            item.description,
            item.title,
            item.images,
            item.visible,
            item.transactiontype,
            item.dpe);
    }

    public hasImages(): boolean {
        return this.images.length !== 0;
    }

    public switchVisibility(): void {
        this.visible = !this.visible;
    }
}
